var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scmcc-error-page"},[_c('div',{staticClass:"error-page-wrapper"},[_c('h2',{staticClass:"error-title"},[_vm._v(_vm._s(_vm.getMessage))])])])}
var staticRenderFns = []

export { render, staticRenderFns }